import axios from "axios";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {baseUrl} from "./Univ.js";
import "./MyStyles.css";
function Menu() {
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    useEffect(() => {
        let active = true;
        const fetchMenu = async () => {
            setLoading(true);
            setError("");
            try {
                const response = await axios.get(`${baseUrl.replace(/\/+$/, "")}/menu/`, {
                    headers: {
                        // Retain your existing tenant identification.
                        ...(localStorage.getItem("hospitalCode") ? {
                            "X-Hospital-Code": localStorage.getItem("hospitalCode")
                        } : {}),
                    },
                });
                const items = response.data?.results;
                if (!Array.isArray(items)) {
                    throw new Error("The menu API returned an invalid response.");
                }
                if (active) {
                    setMenuItems(items);
                }
            } catch (err) {
                console.error("Unable to load DrHiS menu:", err);
                if (active) {
                    setMenuItems([]);
                    setError(err.response?.data?.detail || "Unable to load the menu. Please refresh the page.");
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };
        fetchMenu();
        return () => {
            active = false;
        };
    }, []);
    if (loading) {
        return (<div className="menu-status" role="status">
                <span className="menu-loader"/>
                <span>Loading your menu...</span>
            </div>);
    }
    if (error) {
        return (<div className="menu-error" role="alert">
                <i className="fa-solid fa-circle-exclamation"/>
                <span>{error}</span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => window.location.reload()}
                >
                    Retry
                </button>
            </div>);
    }
    if (menuItems.length === 0) {
        return (<div className="menu-empty">
                <i className="fa-solid fa-folder-open"/>
                <h5>No menu items available</h5>
                <p>
                    Contact your administrator to review your
                    group permissions and menu configuration.
                </p>
            </div>);
    }
    return (<section className="menu-section container-fluid mt-4">
            <div className="row">
                {menuItems.map((item) => {
                    const isExternal = /^https?:\/\//i.test(item.link || "");
                    const card = (<div
                            className="menu-card"
                            style={{
                                "--menu-color": item.color || "#2563EB",
                            }}
                        >
                            <div className="menu-card-bg"/>
                            <div className="menu-card-shine"/>

                            <div className="menu-icon-area">
                                <i
                                    className={`menu-large-icon ${item.icon || "fa-solid fa-folder"}`}
                                    aria-hidden="true"
                                    style={{
                                        color: item.color || "#2563EB",
                                    }}
                                />
                            </div>

                            <div className="menu-title-area">
                                <span className="menu-title">
                                    {item.title}
                                </span>
                            </div>
                        </div>);
                    return (<div
                            key={item.id}
                            className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4"
                        >
                            {isExternal ? (<a
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="menu-link"
                                >
                                    {card}
                                </a>) : (<Link
                                    to={item.link}
                                    className="menu-link"
                                >
                                    {card}
                                </Link>)}
                        </div>);
                })}
            </div>
        </section>);
}
export default Menu;
